module.exports = __webpack_public_path__ + "img/icon-grab-instant.72a6a6a8.png";